module.exports = __webpack_public_path__ + "img/img4.33d998b1.jpg";